// src/features/fourlink-config/components/blocks/Block2Steps/MatrizTipologiasEquipos.jsx

import React from 'react';

export const MatrizTipologiasEquipos = ({
  selectedTipologias,
  selectedEquipos,
  equiposConfig,
  tipologiaEquipoMatrix,
  onToggleTipologiaEquipoSelection,
}) => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Matriz de Tipologías y Equipos/QRs</h2>
      <p className="text-gray-600 mb-6">Selecciona qué equipos y QRs aplican para cada tipología de centro:</p>
      
      <div className="space-y-6">
        {selectedTipologias.length === 0 ? (
          <div className="text-center py-8 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-yellow-700">No hay tipologías seleccionadas</p>
          </div>
        ) : (
          selectedTipologias.map(tipologia => (
            <div key={tipologia} className="border rounded-lg p-6 bg-white">
              <h3 className="text-lg font-semibold text-blue-700 mb-4">{tipologia}</h3>
              
              {selectedEquipos.length === 0 ? (
                <div className="text-center py-4 text-gray-500 italic">
                  No hay equipos seleccionados en el paso anterior
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {selectedEquipos.map(equipo => {
                    const equipoQRs = equiposConfig[equipo]?.qrs || [];
                    const activeQRs = equipoQRs.filter(qr => qr.active);
                    
                    return (
                      <div key={equipo} className="border rounded-lg p-4 bg-gray-50">
                        <h4 className="font-medium text-gray-800 mb-3">{equipo}</h4>
                        
                        {activeQRs.length === 0 ? (
                          <p className="text-xs text-gray-500 italic">Sin QRs activos configurados</p>
                        ) : (
                          <div className="space-y-2">
                            {activeQRs.map(qr => {
                              const isSelected = (tipologiaEquipoMatrix[`${tipologia}-${equipo}`] || []).includes(qr.id);
                              return (
                                <label key={qr.id} className="flex items-center gap-2 cursor-pointer">
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={() => onToggleTipologiaEquipoSelection(tipologia, equipo, qr.id)}
                                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                  />
                                  <span className="text-sm text-gray-700">{qr.name}</span>
                                </label>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};